
import { snakePhp, snakeAxios } from "./ApiService";

export const SharedService= {
    combo(){
        return snakeAxios.get(snakePhp +'transaksi/humas/get-daftar-combo');
    },
    comboOperator(){
        return snakeAxios.get(snakePhp +'transaksi/operator/get-data-combo-operator');
    },
    comboDokter(){
        return snakeAxios.get(snakePhp +'transaksi/dokter/get-data-combo-dokter');
    },
    comboLaporan(){
        return snakeAxios.get(snakePhp +'transaksi/laporan/get-data-combo-laporan');
    },
    comboProduk(){
        return snakeAxios.get(snakePhp +'transaksi/logistik/tambah-mapkfa?idjenisproduk=97');
    },
    comboRekamMedis(){
        return snakeAxios.get(snakePhp +'transaksi/rekam-medis/get-combo');
    },
    getDataLogin(data){
        return snakeAxios.get(snakePhp +'transaksi/tatarekening/get-data-login?noRegistrasi='+data);
    }
}